import { http } from '../helpers/http'
import { buildFindAllUrl } from './shared.service'

const findAllEvents = filters => {
  let url = '/events'
  if (filters) {
    url = buildFindAllUrl(url, filters)
  }
  return http.get(url)
}

export const gridService = {
  findAllEvents
}
